<script setup>
const props = defineProps({
  post: {
    type: Object,
    required: true
  }
})

const PLACEHOLDER = 'https://via.placeholder.com/760x460'
const { altFallback } = usePageAltFallback()

const postImageSrc = computed(() => {
  const image = props.post?.image
  if (image?.url) return image.url
  if (typeof image === 'string' && image) return image
  return PLACEHOLDER
})

const postImageAlt = computed(() =>
  resolveMediaAlt(props.post?.image, props.post?.title, altFallback.value)
)
</script>

<template>
  <a :href="`/blog/${post.slug}`" class="post-container">
    <div class="post-image-container">
      <img
        :src="postImageSrc"
        :alt="postImageAlt"
        loading="lazy"
        decoding="async"
      >
    </div>
    <div class="post-categories">
      <div
        v-for="category in (post.categories || [])"
        :key="category.id || category.attributes?.category"
        class="category"
        v-html="category.attributes.category"
      ></div>
    </div>
    <div class="post-title" v-html="post.title"></div>
    <article v-if="post.shortDescription" class="post-description two-line-text" v-html="post.shortDescription"></article>
  </a>
</template>

<style lang="scss">
.post-container{
  display: block;
  text-decoration: none;
  max-width: 100%;
  padding: 10px;
  border: solid 1px $color-light-gray;
  border-radius: 24px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0);
  margin-bottom: 20px;

  &:hover{
    text-decoration: none;
    font-weight: 400;
    .post-categories{
      font-weight: 400;
    }
    .post-description{
      font-weight: 400;
    }
  }

  .post-image-container{
    margin-bottom: 12px;
    height: 194px;
    border-radius: 12px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .post-categories{
    margin: 10px auto;
    .category{
      display: inline-block;
      background: $color-light-gray;
      padding: 2px 8px;
      border-radius: 10.5px;
      font-size: $font-size-smaller;
      color: $color-labels;
      &:not(:first-child){
        margin-left: 10px;
      }
    }
  }
  .post-title{
    color: $color-labels;
    font-weight: 600;
    padding-bottom: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .post-description{
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    color: $color-subtext;
    p:last-child{
      margin: 0;
    }
  }
  &.featured-post{
    .post-image-container{
      height: 310px;
    }
  }
}
</style>
